import { useEffect, useState } from "react";
import "./Matches.css";
import "./Loader.jsx";
import profileIcon from "../icons/profile.png";
import locationIcon from "../icons/location.png";
import religionIcon from "../icons/religion.png";
import educationIcon from "../icons/scholar.png";
import userAvatar from "../img/user-avatar.png";
import bagIcon from "../icons/bag.png";
import { Link } from "react-router-dom";
import swooshIcon from "../icons/Swoosh.png";
import redstarIcon from "../icons/Redstar.png";
import addfavStarIcon from "../icons/add-short.png";
import removefavStarIcon from "../icons/fav-star.png";
import heartIcon from "../icons/heartIcon.png";
import searchIcon from "../icons/searchIcon.png";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Loader.jsx";
import { useTranslation } from "react-i18next";
import {
  fetchMatches,
  fetchProfiles,
  sendInterestToProfile,
  userAddShortlistProfile,
} from "../redux/matchFilterSlice";
import { fetchRecommendedMatches } from "../redux/profileFilterSlice";

const profilesStatic = [
  {
    id: 1,
    name: "Razitha ",
    age: 27,
    state: "Tamil Nadu",
    location: "Chennai",
    education: "Post Grad",
    profession: "Doctor",
    religion: "Hindu",
    caste: "Gounder",
    bio: "Family-oriented, loves classical dance and travel. Seeks a partner who values traditions.",
    match: 97,
    verified: true,
    marital: "Never Married",
    color: "#f3e8ee",
    lifestyle: ["Vegetarian"],
    income: "3–6L",
    height: "5'6\"",
  },
  {
    id: 2,
    name: "Sajitha ",
    age: 26,
    location: "Hyderabad",
    state: "Andhra Pradesh",
    education: "Graduate",
    profession: "IT / Software",
    religion: "Hindu",
    caste: "Brahmin",
    bio: "Passionate about technology and cooking. Looking for a caring, ambitious life partner...",
    match: 95,
    verified: true,
    marital: "Never Married",
    color: "#e8eef3",
    lifestyle: ["Non-Veg OK"],
    income: "3L–6L",
    height: "5'2\"",
  },
  {
    id: 3,
    name: "Priya Murugan",
    age: 27,
    location: "Bangalore",
    state: "Karnataka",
    education: "PhD",
    profession: "IT / Software",
    religion: "Jain",
    caste: "Digambar",
    bio: "Dedicated doctor with a heart for service.",
    match: 93,
    verified: true,
    marital: "Never Married",
    color: "#eef3e8",
    lifestyle: ["Non-Veg OK"],
    income: "3L–6L",
    height: "5'0\"",
  },
  {
    id: 4,
    name: "Robert ",
    age: 25,
    location: "Trivandrum",
    state: "Kerala",
    education: "Diploma",
    profession: "Teacher",
    religion: "Christian",
    caste: "CSI",
    bio: "Data enthusiast and weekend trekker.",
    match: 91,
    verified: true,
    marital: "Divorced",
    color: "#f3ede8",
    lifestyle: ["Non-Smoker"],
    income: "6L–12L",
    height: "5'2\"",
  },
  {
    id: 5,
    name: "Esther",
    age: 29,
    location: "Salem",
    state: "Tamil Nadu",
    education: "Post Grad",
    profession: "Chartered Accountant",
    religion: "Christian",
    caste: "Roman Catholic",
    bio: "Pragmatic and warm-hearted.",
    match: 95,
    verified: true,
    marital: "Divorced",
    color: "#eee8f3",
    lifestyle: ["Fitness"],
    income: "25L+",
    height: "5'8\"",
  },
  {
    id: 6,
    name: "Begham ",
    age: 27,
    state: "Tamil Nadu",
    location: "Trichy",
    education: "Post Grad",
    profession: "Engineer",
    religion: "Muslim",
    caste: "Pathan",
    bio: "Creative soul who designs beautiful spaces.",
    match: 87,
    verified: true,
    marital: "Widowed",
    color: "#f3f0e8",
    lifestyle: ["Fitness"],
    income: "12L–25L",
    height: "5'10\"",
  },
];

const recommended = profilesStatic.slice(0, 4);

const getMatchColor = (score) => {
  if (score >= 50) return "#7a6a00";
  return "#8b1a1a";
};

function Avatar({ profileId, color, name, profileIcon, photos }) {
  // console.log('Avatar:photos', photos);
  // console.log('Avatar:photos', `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/uploads/${photos?.url || ""}`);
  const imageUrl = photos?.url
    ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${photos.url}`
    : userAvatar || "/default-avatar.png";
  const initials = name
    ?.split(" ")
    .map((n) => n[0])
    .join("");
  return (
    <div
      className="avatar-profile"
      style={{
        background: color,
        width: "100%",
        height: "220px",        // ← fixed height so crop works
        overflow: "hidden",     // ← clips everything outside
        borderRadius: "10px",   // optional, match your card style
      }}
    >
     <Link to={`/profile/${profileId}`} className="avatar-link" style={{ display: "block", height: "100%" }}>
        {/* <span className="avatar-initials">{initials}</span> */}
        {/* <img src={profileIcon ?? userAvatar} alt="profile" className="avatar-img" /> */}
        <img
          src={imageUrl}
          alt="profile"
          className="avatar-img"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "top center", // ← shows face not feet
            display: "block",
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = userAvatar;
          }}
        />
      </Link>
    </div>
  );
}

function MatchBadge({ score }) {
  return (
    <span
      className="match-badge"
      style={{
        background: getMatchColor(score) + "18",
        color: getMatchColor(score),
        border: `1px solid ${getMatchColor(score)}33`,
      }}
    >
      {score}% Match
    </span>
  );
}

function RecommendedCard({ profile, onStar, starred }) {
  const location = [
    profile?.location?.city,
    profile?.location?.state,
    profile?.location?.country,
  ]
    .filter(Boolean)
    .join(", ");
  return (
    <div className="rec-card">
      <div className="rec-card-star" onClick={() => onStar(profile._id)}>
        {starred ? "★" : "☆"}
      </div>
      <Avatar
        profileId={profile._id}
        color={profile?.color}
        name={profile?.name}
        profileIcon={profile?.profileIcon}
        photos={profile?.photos}
      />
      {/* <Avatar color={profile.color} name={profile.name} /> */}
      <div className="rec-card-name">
        {profile.name.split(" ")[0]}{" "}
        {profile.name.split(" ")[1] ? profile.name.split(" ")[1][0] + "." : ""}
      </div>
      <div className="rec-card-info">
        {profile.age} · {location}
      </div>
      {localStorage.getItem("token") && (
        <div className="rec-card-match">
          <MatchBadge score={profile.matchPercent} />
        </div>
      )}
    </div>
  );
}

function ProfileCard({ profile, onStar, starred, onInterest, interested }) {
  // console.log('profile:data', profile);
  const profileUrl = `/profile/${profile._id}`;
  const primary = profile.photos?.find((p) => p.isPrimary);
  const location = [
    profile?.location?.city,
    profile?.location?.state,
    profile?.location?.country,
  ]
    .filter(Boolean)
    .join(", ");
  return (
    // <Link to={`/profile/${profile.id}`} className="profile-link">
    <div className={`profile-card ${interested ? "interested" : ""}`}>
      {/* <button className="card-star-btn" onClick={() => onStar(profile._id)}>
        {starred ? "★" : "☆"}
      </button> */}
      <Avatar
        profileId={profile._id}
        color={profile.color}
        name={profile.name}
        profileIcon={profile?.profileIcon}
        photos={primary}
      />
      <div className="card-body">
        <div className="card-header-row">

      
            <div className="card-main-info">
    <span className="card-name">
      {profile?.fullName
        ? profile.fullName
        : `${profile?.firstName || ""} ${profile?.lastName || ""}`.trim() || "N/A"}
    </span>
    <span className="verified-box">
      <img src={swooshIcon} alt="verified" className="verified-icon" />
      <span>Verified</span>
    </span>
  </div>
            <div className="card-meta">
              <span className="card-age">{profile.age} yrs</span>
              <span className="dot">·</span>
              <div className="location-row">
                <img
                  src={locationIcon}
                  alt="location"
                  className="location-icon"
                />
                <span className="card-location">{location}</span>
              </div>
            </div>
            <div className="card-profession">
              <img
                src={educationIcon}
                alt="education"
                className="inline-icon"
              />
              {profile.education || "N/A"} · {profile.profession || "N/A"}
            </div>
          
          {/* {profile.verified && ( */}
            
          {/* )} */}
        </div>
        <p className="card-bio">{profile.aboutMe}</p>
        {localStorage.getItem("token") && (
          <div className="match-progress-bar">
            <div
              className="match-progress-fill"
              style={{ width: `${profile.match}%` }}
            />
          </div>
        )}
        <div className="card-footer">
          {localStorage.getItem("token") && (
            <div className="compat-row">
              <span className="compat-label">Compatibility score</span>
              <MatchBadge score={profile?.matchPercent} />
            </div>
          )}
          <div className="card-actions">
            <button
              className={`btn-interest ${interested ? "sent" : ""}`}
              onClick={() => onInterest(profile._id)}
            >
              <img src={heartIcon} alt="heart" className="heart-icon" />
              {profile?.interestStatus === "accepted"
                ? " Interest Accepted"
                : profile?.interestStatus === "rejected"
                  ? " Interest Rejected"
                  : profile?.interestStatus === "pending"
                    ? " Interest Sent"
                    : " Send Interest"}
              {/* {['pending', 'sent', 'rejected','accepted'].includes(profile?.interestStatus) ? " Interest Sent" : " Send Interest"} */}
            </button>
            <div className="button-saving"> 
            <button className="btn-save" onClick={() => onStar(profile._id)}>
              <img
                src={
                  profile?.isShortlisted ? removefavStarIcon : addfavStarIcon
                }
                alt="favStarIcon"
                className="favstar-icon"
              />
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const appliedFilters_INITIAL = {
   gender: "",
  ageMin: 18,
  ageMax: 50,
  location: "All States",
  city: "All Cities",
  religion: "All Religions",
  caste: "Any Caste",
  education: [],
  profession: "All Professions",
  marital: [],
  heightMin: "", //4'10\"
  heightMax: "",  //6'2\"
  income: [],
  lifestyle: [],
};

const casteOptions = {
  Hindu: ["Brahmin", "Mudaliar", "Nadar", "Gounder"],
  Muslim: ["Shia", "Pathan"],
  Christian: ["Roman Catholic", "CSI", "Protestant"],
  Jain: ["Digambar", "Shwetambar"],
};

// const cityOptions = {
//   "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Salem", "Trichy"],
//   Karnataka: ["Bangalore"],
//   Kerala: ["Kochi", "Trivandrum"],
//   "Andhra Pradesh": ["Hyderabad", "Vijayawada"]
// };

export default function Matches() {
  const [appliedFilters, setappliedFilters] = useState(appliedFilters_INITIAL);
  const [activeappliedFilters, setActiveappliedFilters] = useState([]);
  const [starred, setStarred] = useState([]);
  const [interested, setInterested] = useState([]);
  const [allFilterTypes, setAllFilterTypes] = useState([]);
  const [states, setStates] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [religion, setReligion] = useState([]);
  const [caste, setCaste] = useState([]);
  const [profession, setProfession] = useState([]);
  const [recommendedProfiles, setRecommendedProfiles] = useState([]);
  const [allProfiles, setAllProfiles] = useState([]);
  const [education, setEducation] = useState(appliedFilters_INITIAL.education);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("Most Relevant");
  const [page, setPage] = useState(1);
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mobileappliedFiltersOpen, setMobileappliedFiltersOpen] =
    useState(false);
  const dispatch = useDispatch();
  // ✅ Read from Redux store
  const { list, error } = useSelector((state) => state.matches);
  console.log("matchlist:", list);
  const { profiles } = useSelector((state) => state.matches);
  const { recommendedMatches } = useSelector((state) => state.profile);
  const {t, i18n} = useTranslation();
  useEffect(() => {
    dispatch(fetchRecommendedMatches());
  }, [dispatch]);

  useEffect(() => {
    if (recommendedMatches?.matches) {
      console.log("Recommended Matches:", recommendedMatches);
      let recommendedProfiles = [];
      let data = recommendedMatches.matches;
      data?.slice(0, 4).forEach((match) => {
        const profileURL = match.photos.find((photo) => photo.isPrimary);
        console.log("Profile URL:", profileURL);

        recommendedProfiles.push({
          _id: match._id,
          name: match?.fullName ?? match.firstName + " " + match.lastName,
          age: match.age,
          location: match.location,
          photos: profileURL ?? userAvatar,
          matchPercent: match.matchPercent,
        });
      });
      setRecommendedProfiles(recommendedProfiles);
    }
  }, [recommendedMatches]);

  useEffect(() => {
    dispatch(fetchMatches());
    setLoading(true);
    // setTimeout(() => {
      dispatch(fetchProfiles()).unwrap().then((res) =>{
        setLoading(false);
      })
    // }, 5000);
    
    
  }, [dispatch]);

  useEffect(() => {
    if (list?.data) {
      const types = list.data;
      setAllFilterTypes(types);

      const religions = types
        .filter((f) => f.isActive && f.masterType === "Religion")
        .map((r) => r);

      setReligion(religions);
      console.log("religion:", religion);

      const castes = types
        .filter((f) => f.isActive && f.masterType === "Caste" && f.parentId?._id !== null)
        .map((c) => c);
      setCaste(castes);
      console.log("caste:", castes);

      //get occupation list
      const professions = types
        .filter((f) => f.isActive && f.masterType === "Occupation")
        .map((p) => p);
      setProfession(professions);
      console.log("profession:", professions);

      //get state list
      const states = types
        .filter((f) => f.isActive && f.masterType === "State")
        .map((s) => s);
      setStates(states);
      console.log("states:", states);

      //get education list
      const education = types
        .filter((f) => f.isActive && f.masterType === "Education")
        .map((e) => e);
      setEducation(education);
      console.log("education:", education);
    }
  }, [list]);

  useEffect(() => {
    console.log("apiprofiles:", profiles);
    if (profiles?.profiles) {
      setAllProfiles(profiles?.profiles);
    }
    console.log("allProfiles:", allProfiles);
  }, [profiles]);

  //     useEffect(() => {
  //     const tags = [];
  //      if (appliedFilters.location) {
  //     tags.push(getNameById(states, appliedFilters.location));
  //   }
  //     // if (appliedFilters.location !== "All States") tags.push(appliedFilters.location);
  //     if (appliedFilters.city !== "All Cities") tags.push(appliedFilters.city);
  //     tags.push(`Age: ${appliedFilters.ageMin}–${appliedFilters.ageMax}`);
  //     if (appliedFilters.profession !== "All Professions") tags.push(appliedFilters.profession);
  //     if (appliedFilters.religion !== "All Religions") tags.push(appliedFilters.religion);
  //     if (appliedFilters.education !== "All education") tags.push(appliedFilters.education);
  //     if (appliedFilters.lifestyle !== "All lifestyle") tags.push(appliedFilters.lifestyle);
  //     if (appliedFilters.marital.length > 0) {tags.push(...appliedFilters.marital);}
  //   if (appliedFilters.income !== "All income") tags.push(appliedFilters.income);
  // console.log('Active Applied Filters:', tags);

  //     setActiveappliedFilters(tags);
  //   }, [appliedFilters]);

  useEffect(() => {
    const tags = [];
    console.log("ActiveappliedFilters:", appliedFilters);

    // ✅ GENDER
    if (appliedFilters.gender) {
      const genderLabel = t(appliedFilters.gender.toLowerCase());
      tags.push({
        label: genderLabel,
        key: "gender",
        value: appliedFilters.gender,
      });
    }

    // ✅ LOCATION (only if selected)
    if (appliedFilters.location) {
      console.log("Location_states:", states);

      const name = getNameById(states, appliedFilters.location);
      console.log("Location_name:", name);
      
      if (name) {
        tags.push({
          label: name,
          key: "location",
          value: appliedFilters.location,
        });
      }
    }

    // ✅ CITY
    if (appliedFilters.city) {
      console.log("City_cname:", cityOptions);
      const name = getNameById(cityOptions, appliedFilters.city);
      console.log("City_cname:", name);

      if (name) {
        tags.push({ label: name, key: "city", value: appliedFilters.city });
      }
    }

    // ✅ AGE (only if changed from default)
    if (appliedFilters.ageMin && appliedFilters.ageMax) {
      tags.push({
        label: `Age: ${appliedFilters.ageMin}–${appliedFilters.ageMax}`,
        key: "age",
        value: {
          min: appliedFilters.ageMin,
          max: appliedFilters.ageMax,
        },
      });
    }

    // ✅ HEIGHT (only if changed from default)

    // ✅ HEIGHT (range)
    if (appliedFilters.heightMin && appliedFilters.heightMax) {
      tags.push({
        key: "height",
        label: `Height: ${appliedFilters.heightMin} – ${appliedFilters.heightMax}`,
        value: {
          min: appliedFilters.heightMin,
          max: appliedFilters.heightMax,
        },
      });
    }

    // ✅ RELIGION
    if (appliedFilters.religion) {
      const name = getNameById(religion, appliedFilters.religion);
      if (name) {
        tags.push({
          label: name,
          key: "religion",
          value: appliedFilters.religion,
        });
      }
    }

    // ✅ CASTE
    if (appliedFilters.caste) {
      const name = getNameById(caste, appliedFilters.caste);
      if (name) {
        tags.push({ label: name, key: "caste", value: appliedFilters.caste });
      }
    }

    // ✅ EDUCATION
    if (appliedFilters.education?.length) {
      const names = getNameById(education, appliedFilters.education);

      appliedFilters.education.forEach((id, index) => {
        tags.push({
          label: names[index], // display name
          key: "education",
          value: id, // ✅ VERY IMPORTANT
        });
      });
      // if (name) {
      //   tags.push({ label: name, key: "education" });
      // }
    }

    // ✅ PROFESSION
    if (appliedFilters.profession) {
      const name = getNameById(profession, appliedFilters.profession);
      if (name) {
        tags.push({
          label: name,
          key: "profession",
          value: appliedFilters.profession,
        });
      }
    }

    // ✅ LIFESTYLE (if not default)
    if (appliedFilters.lifestyle?.length) {
      console.log("Lifestyle:", appliedFilters.lifestyle);
      appliedFilters.lifestyle.forEach((id, index) => {
        if (id === "Never") {
          appliedFilters.lifestyle[index] = "Non-Smoker";
        }
        tags.push({
          label: appliedFilters.lifestyle[index],
          key: "lifestyle",
          value: id,
        });
      });
    }

    // ✅ MARITAL
    if (appliedFilters.marital?.length > 0) {
      // const martialType = getNameById(education, appliedFilters.marital);
      console.log("Marital types:", appliedFilters.marital);

      appliedFilters.marital.forEach((id, index) => {
        console.log("Marital:", id, index);

        tags.push({
          label: id, // display name
          key: "marital",
          value: id, // ✅ VERY IMPORTANT
        });
        // tags.push({ label: m, key: "marital" });
      });
    }

    // ✅ INCOME
    if (appliedFilters.income?.length) {
      appliedFilters.income.forEach((id, index) => {
        tags.push({
          label: appliedFilters.income[index],
          key: "income",
          value: id,
        });
      });
    }

    setActiveappliedFilters(tags);
  }, [appliedFilters, states, cityOptions, religion, caste, education, profession]);
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

  console.log("religion:", religion);

  const toggleStar = async (id) => {
    console.log("toggleStar:", id);
    // user not login show toast
    if (!checkUserLogin("Please login to shortlist profiles.")) {
      return; //  stops execution
    }
    setStarred((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
    const shortlist = await dispatch(userAddShortlistProfile(id));
    console.log("shortlist:", shortlist);
    let message = shortlist;
    console.log("toastMessage:", message?.payload?.message);
    showToast(message?.payload?.message || "Profile shortlisted!", "success");
    await dispatch(fetchProfiles());
    await dispatch(fetchRecommendedMatches());
  };

  // check user login
  const checkUserLogin = (msg) => {
    const token = localStorage.getItem("token");

    if (!token) {
      showToast(msg, "error");
      return false;
    }

    return true;
  };

  const toggleInterest = async (id) => {
    console.log("toggleInterest:", id);
    // user not login show toast
    if (!checkUserLogin("Please login to send interest.")) {
      return; // ✅ stops execution
    }
    // setInterested((prev) =>
    //   prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    // );
    const interest = dispatch(sendInterestToProfile(id));
    console.log("interest:", await interest);
    let message = await interest;
    console.log("toastMessage:", message?.payload?.message);

    showToast(message?.payload?.message || "Interest sent!", "success");
    dispatch(fetchProfiles());
    dispatch(fetchRecommendedMatches());
  };

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };
  // const removeFilter = (tag) =>{
  //   console.log('Removing filter:', tag)
  //   setActiveappliedFilters((prev) => prev.filter((f) => f.key !== tag));
  // }

  const removeFilter = (key, value) => {
    console.log("Removing filter:", key, value);

    setappliedFilters((prev) => {
      // ✅ HEIGHT (reset both)
      if (key === "height") {
        return {
          ...prev,
          heightMin: "",
          heightMax: "",
        };
      } else if (key === "age") {
        return {
          ...prev,
          ageMin: 0,
          ageMax: 0,
        };
      }

      // ✅ array filters
      if (Array.isArray(prev[key])) {
        return {
          ...prev,
          [key]: prev[key].filter((item) => String(item) !== String(value)),
        };
      }

      // ✅ default single
      return {
        ...prev,
        [key]: "",
      };
    });
  };
  //   const removeFilter = (key) => {
  //   console.log("Removing:", key);

  //   setappliedFilters(prev => {
  //     switch (key) {
  //       case "location":
  //         return {
  //           ...prev,
  //           location: "",
  //           city: "" // also reset city when state removed
  //         };

  //       case "city":
  //         return {
  //           ...prev,
  //           city: ""
  //         };

  //       case "religion":
  //         return {
  //           ...prev,
  //           religion: "",
  //           caste: "" // dependent reset
  //         };

  //       case "caste":
  //         return {
  //           ...prev,
  //           caste: ""
  //         };

  //       case "education":
  //         return {
  //           ...prev,
  //           education: ""
  //         };

  //       case "profession":
  //         return {
  //           ...prev,
  //           profession: ""
  //         };

  //       case "lifestyle":
  //         return {
  //           ...prev,
  //           lifestyle: ""
  //         };

  //       case "income":
  //         return {
  //           ...prev,
  //           income: ""
  //         };

  //       case "marital":
  //         return {
  //           ...prev,
  //           marital: []
  //         };

  //       case "age":
  //         return {
  //           ...prev,
  //           ageMin: 18,
  //           ageMax: 50
  //         };

  //       default:
  //         return prev;
  //     }
  //   });
  // };

  const filtered = allProfiles;

  //   const filtered = profiles.filter((p) => {

  //   const matchesSearch =
  //     !search ||
  //     p.name.toLowerCase().includes(search.toLowerCase()) ||
  //     p.location.toLowerCase().includes(search.toLowerCase()) ||
  //     p.profession.toLowerCase().includes(search.toLowerCase());

  //   const matchesAge =
  //     p.age >= appliedFilters.ageMin && p.age <= appliedFilters.ageMax;

  //   const matchesState =
  //   appliedFilters.location === "All States" ||
  //   p.state === appliedFilters.location;

  // const matchesCity =
  //   appliedFilters.city === "All Cities" ||
  //   p.location === appliedFilters.city;

  //   const matchesProfession =
  //     appliedFilters.profession === "All Professions" ||
  //     p.profession.toLowerCase().includes(appliedFilters.profession.toLowerCase());

  //   const matchesReligion =
  //   appliedFilters.religion === "All Religions" ||
  //   p.religion === appliedFilters.religion;

  //  const matchesCaste =
  //   appliedFilters.caste === "Any Caste" ||
  //   (appliedFilters.religion === "All Religions" &&
  //     p.caste === appliedFilters.caste) ||
  //   (p.religion === appliedFilters.religion &&
  //     p.caste === appliedFilters.caste);

  //   const matchesEducation =
  //     appliedFilters.education.includes("Any") ||
  //     appliedFilters.education.some((e) =>
  //       p.education.toLowerCase().includes(e.toLowerCase())
  //     );

  //   const matchesMarital =
  //   appliedFilters.marital.length === 0 ||
  //   appliedFilters.marital.includes(p.marital);

  // const matchesIncome =
  //   appliedFilters.income.includes("Any") ||
  //   appliedFilters.income.includes(p.income);

  // const heightToInches = (h) => {
  //   const [feet, inches] = h.replace('"', '').split("'").map(Number);
  //   return feet * 12 + inches;
  // };

  // const matchesHeight =
  //   heightToInches(p.height) >= heightToInches(appliedFilters.heightMin) &&
  //   heightToInches(p.height) <= heightToInches(appliedFilters.heightMax);

  // const matchesLifestyle =
  //   appliedFilters.lifestyle.includes("Any") ||
  //   appliedFilters.lifestyle.some((l) =>
  //     p.lifestyle.some((pl) => pl.toLowerCase() === l.toLowerCase())
  //   );

  //   return (
  //   matchesSearch &&
  //   matchesAge &&
  //   matchesState &&
  //   matchesCity &&
  //   matchesReligion &&
  //   matchesCaste &&
  //   matchesProfession &&
  //   matchesEducation &&
  //   matchesMarital &&
  //   matchesLifestyle &&
  //   matchesIncome &&
  //   matchesHeight
  // );
  // });
  const sorted = [...filtered].sort((a, b) => {
    if (sort === "Highest Match") return b.matchPercent - a.matchPercent;
    if (sort === "Lowest Match") return a.matchPercent - b.matchPercent;
    return 0;
  });
  console.log("Filtered_sorted:", sorted);

  const ITEMS_PER_PAGE = 10;

  // const paginated = sorted.slice(
  //   (page - 1) * ITEMS_PER_PAGE,
  //   page * ITEMS_PER_PAGE
  // );

  const toggleEducation = (val) => {
    setappliedFilters((prev) => {
      const has = prev.education.includes(val);
      return {
        ...prev,
        education: has
          ? prev.education.filter((e) => e !== val)
          : [...prev.education.filter((e) => e !== "Any"), val],
      };
    });
  };

  const toggleMarital = (val) => {
    setappliedFilters((prev) => {
      const has = prev.marital.includes(val);
      return {
        ...prev,
        marital: has
          ? prev.marital.filter((e) => e !== val)
          : [...prev.marital, val],
      };
    });
  };

  const toggleIncome = (val) => {
    setappliedFilters((prev) => {
      if (val === "Any") return { ...prev, income: ["Any"] };
      const has = prev.income.includes(val);
      let updated = has
        ? prev.income.filter((e) => e !== val)
        : [...prev.income.filter((e) => e !== "Any"), val];
      if (updated.length === 0) updated = ["Any"];
      return { ...prev, income: updated };
    });
  };

  const toggleLifestyle = (val) => {
    if (
      !appliedFilters.lifestyle?.includes("Non-Smoker") &&
      val === "Non-Smoker"
    ) {
      val = "Never";
    }
    setappliedFilters((prev) => {
      if (val === "Any") {
        return { ...prev, lifestyle: ["Any"] };
      }

      const has = prev.lifestyle.includes(val);

      let updated = has
        ? prev.lifestyle.filter((e) => e !== val)
        : [...prev.lifestyle.filter((e) => e !== "Any"), val];

      if (updated.length === 0) updated = ["Any"];

      return { ...prev, lifestyle: updated };
    });
  };

  // Function to get cities based on selected state
  const getCastBasedonReligion = (religionId) => {
    // Implementation for fetching castes based on religion
    console.log("Fetching castes for religion:", religionId);
    if (!religionId) {
      setCaste(allFilterTypes.filter((f) => f.masterType === "Caste"));
      return;
    }
    const castes = allFilterTypes.filter(
      (f) => f.masterType === "Caste" && f.parentId?._id === religionId,
    );
    setCaste(castes);
    console.log("caste:", castes);
  };

  //
  const getCityBasedonState = (stateId, e) => {
    console.log("Fetching cities for state:", stateId);
    console.log("Event:", e);
    const state = allFilterTypes.filter(
      (f) => f.masterType === "State" && f._id === stateId,
    )[0].masterValue?.[i18n.language];
    // console.log("getCityBasedonState:", state);
    // setappliedFilters({ ...appliedFilters, location: state });
    // if(!stateId) {
    //   const cities = allFilterTypes.filter(f => f.masterType === "City");
    //   setCityOptions(cities);
    //   return;
    // }
    const cities = allFilterTypes.filter(
      (f) => f.masterType === "City" && f.parentId?._id === stateId,
    );
    setCityOptions(cities);
    console.log("cities:", cities);
  };

  //   const getNameById = (list, id) => {
  // console.log('List:', list);
  // console.log('ID:', id);
  //  if (!Array.isArray(list)) return "";
  //   return list?.find(item => String(item._id) === String(id))?.masterValue || "";
  // };

  const getNameById = (list, id) => {
    console.log("getNameById:", list, id);
    
    if (!Array.isArray(list)) return "";

    // ✅ If ID is array (multi-select)
    if (Array.isArray(id)) {
      return list
        .filter((item) => id.map(String).includes(String(item._id)))
        .map((item) => item.masterValue?.["en"] || "");
    }

    // ✅ If single ID
    return (
      list.find((item) => String(item._id) === String(id))?.masterValue?.["en"] || ""
    );
  };

  console.log("appliedFilters:", appliedFilters);
  console.log("activeappliedFilters:", activeappliedFilters);

    const normalize = (value) =>
  value?.toString().trim().toLowerCase().replace(/\s+/g, "");

  const parseHeight = (h) => {
    if (!h) return 0;
    const [feet, inches] = h.split("'").map(Number);
    return feet * 12 + (inches || 0);
  };

  console.log("Grouped_Filters:", activeappliedFilters);

  const groupedFilters = activeappliedFilters.reduce((acc, f) => {
    if (!acc[f.key]) acc[f.key] = [];
    acc[f.key].push(f.value);
    return acc;
  }, {});

  const stateMap = states.reduce((acc, item) => {
    acc[item._id] = item.masterCode.toLowerCase();
    return acc;
  }, {});

  const cityMap = cityOptions.reduce((acc, item) => {
    acc[item._id] = item.masterCode.toLowerCase();
    return acc;
  }, {});

  const religionMap = religion.reduce((acc, item) => {
    acc[item._id] = item.masterCode.toLowerCase();
    return acc;
  }, {});

  // const casteMap = caste.reduce((acc, item) => {
  //   acc[item._id] = item.masterCode?.toLowerCase();
  //   return acc;
  // }, {});

  const casteMap = caste.reduce((acc, item) => {
  acc[item._id] = normalize(
    item.masterValue?.en || item.masterCode
  );
  return acc;
}, {});

  const educationMap = education.reduce((acc, item) => {
    acc[item._id] = item.masterCode?.toLowerCase();
    return acc;
  }, {});

  const professionMap = profession.reduce((acc, item) => {
    acc[item._id] = item.masterCode?.toLowerCase();
    return acc;
  }, {});

  let filteredProfiles = allProfiles?.filter((p) => {
    const gender = p.gender?.toLowerCase();
    const profileState = p.location?.state?.toLowerCase();
    const profileCity = p.location?.city?.toLowerCase();
    const profileReligion = p.religion?.toLowerCase();
    const profileCaste = normalize(p.caste);
    const profileEducation = p.education?.toLowerCase();
    const profileProfession = p.profession?.toLowerCase();
    const profileHeight = parseHeight(p.height);
    const searchText = search?.toLowerCase() || "";

    const matchesSearch =
      !searchText ||
      p.fullName?.toLowerCase().includes(searchText) ||
      p.location?.city?.toLowerCase().includes(searchText) ||
      p.location?.state?.toLowerCase().includes(searchText) ||
      p.profession?.toLowerCase().includes(searchText);

    if (!matchesSearch) return false;

    const normalizeState = (value) => value?.toLowerCase().replace(/\s+/g, "");

    // ✅ GENDER
    if (groupedFilters.gender?.length) {
      const selectedGenders = groupedFilters.gender.map((g) => g.toLowerCase());
      if (!selectedGenders.includes(gender)) return false;
    }

    // ✅ LOCATION
    if (groupedFilters.location?.length) {
      const selectedStates = groupedFilters.location
        .map((id) => stateMap[id]?.toLowerCase())
        .filter(Boolean);
      if (!selectedStates.includes(normalizeState(profileState))) return false;
    }

    // ✅ CITY
    if (groupedFilters.city?.length) {
      const selectedCities = groupedFilters.city
        .map((id) => cityMap[id]?.toLowerCase())
        .filter(Boolean);

      if (!selectedCities.includes(profileCity)) return false;
    }

    // ✅ AGE
    if (groupedFilters.age?.length) {
      const { min, max } = groupedFilters.age[0];
      if (p.age < min || p.age > max) return false;
    }

    // ✅ HEIGHT
    if (groupedFilters.height?.length) {
      const { min, max } = groupedFilters.height[0];
      const minHeight = parseHeight(min);
      const maxHeight = parseHeight(max);

      if (profileHeight < minHeight || profileHeight > maxHeight) return false;
    }

    // ✅ RELIGION
    if (groupedFilters.religion?.length) {
      const selectedReligions = groupedFilters.religion
        .map((id) => religionMap[id]?.toLowerCase())
        .filter(Boolean);

      if (!selectedReligions.includes(profileReligion)) return false;
    }

    // ✅ CASTE
      // let selectedCastes = [];
//     if (groupedFilters.caste?.length) {
//        const selectedCastes = groupedFilters.caste
//         .map((id) => casteMap[id]?.toLowerCase())
//         .filter(Boolean);
// console.log("selectedCastes:", selectedCastes, "profileCaste:", profileCaste,selectedCastes.includes(profileCaste));
//       if (!selectedCastes.includes(profileCaste)) return false;
//     }

if (groupedFilters.caste?.length) {
  const selectedCastes = groupedFilters.caste
    .map((id) => normalize(casteMap[id]))
    .filter(Boolean);

  if (!selectedCastes.includes(profileCaste)) {
    return false;
  }
}

    // console.log('profileProfession_educationMap:', educationMap);
    // ✅ EDUCATION
    if (groupedFilters.education?.length) {
      const selectedEducation = groupedFilters.education
        .map((id) => educationMap[id]?.toLowerCase())
        .filter(Boolean);

      if (!selectedEducation.includes(profileEducation)) return false;
    }

    // console.log('groupedFilters_prof:', groupedFilters.profession);
    // console.log('profileProfession_professionMap:', professionMap);
    // console.log('profileProfession_profile:', profileProfession);

    // ✅ PROFESSION
    if (groupedFilters.profession?.length) {
      const selectedProfessions = groupedFilters.profession
        .map((id) => professionMap[id]?.toLowerCase())
        .filter(Boolean);
      console.log("selectedProfessions_prof:", selectedProfessions);
      if (!selectedProfessions.includes(profileProfession)) return false;
    }

    // ✅ MARITAL
    if (groupedFilters.marital?.length) {
      if (!groupedFilters.marital.includes(p.maritalStatus)) return false;
    }

    // ✅ INCOME
    if (groupedFilters.income?.length) {
      if (!groupedFilters.income.includes(p.salary)) return false;
    }

    // ✅ LIFESTYLE
    if (
      groupedFilters.lifestyle?.length &&
      groupedFilters.lifestyle[0] !== "Any"
    ) {
      const lifestyleValues = groupedFilters.lifestyle.map((v) =>
        v.toLowerCase(),
      );

      const profileLifestyle = [
        p.diet?.toLowerCase(),
        p.smoking?.toLowerCase(),
        p.drinking?.toLowerCase(),
      ].filter(Boolean);

      const hasLifestyleMatch = lifestyleValues.some((value) =>
        profileLifestyle.includes(value),
      );

      if (!hasLifestyleMatch) return false;
    }

    return true;
  });

  console.log("Filtered Profiles:", filteredProfiles);

  // const filteredProfiles = useMemo(() => {
  //   return allProfiles.filter((p) => {
  //     // same logic here
  //   });
  // }, [allProfiles, appliedFilters]);

  const itemsPerPage = 5;
  const currentPage = 1; // this should come from state
  // filteredProfiles = filteredProfiles.slice(
  //   (page - 1) * ITEMS_PER_PAGE,
  //   page * ITEMS_PER_PAGE
  // );
  const sortedProfiles = [...filteredProfiles].sort((a, b) => {
    if (sort === "Highest Match")
      return (b.matchPercent || 0) - (a.matchPercent || 0);

    if (sort === "Lowest Match")
      return (a.matchPercent || 0) - (b.matchPercent || 0);

    if (sort === "Age Low to High") return (a.age || 0) - (b.age || 0);

    if (sort === "Age High to Low") return (b.age || 0) - (a.age || 0);

    return 0;
  });

  const paginatedProfiles = sortedProfiles.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE,
  );

  const totalPages = Math.ceil(filteredProfiles.length / ITEMS_PER_PAGE);

const getPageNumbers = () => {
  // If there are only a few pages, show all
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  // Beginning
  if (page <= 4) {
    return [1, 2, 3, 4, 5, "...", totalPages];
  }

  // End
  if (page >= totalPages - 3) {
    return [
      1,
      "...",
      totalPages - 4,
      totalPages - 3,
      totalPages - 2,
      totalPages - 1,
      totalPages,
    ];
  }

  // Middle
  return [
    1,
    "...",
    page - 1,
    page,
    page + 1,
    "...",
    totalPages,
  ];
};

  const total = paginatedProfiles?.length || 0;
  const startIndex = (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(currentPage * itemsPerPage, total);

  const lifestyleOptions = [
  {
    key: "Any",
    label: t("lifestyle_any"),
  },
  {
    key: "Vegetarian",
    label: t("lifestyle_vegetarian"),
  },
  {
    key: "Non-Vegetarian",
    label: t("lifestyle_non_veg"),
  },
  {
    key: "Non-Smoker",
    label: t("lifestyle_non_smoker"),
  },
  {
    key: "Fitness",
    label: t("lifestyle_fitness"),
  },
];

const incomeOptions = [
  {
    key: "Any",
    label: t("income_any"),
  },
  {
    key: "Below 10K",
    label: t("income_below_10k"),
  },
  {
    key: "10K – 25K",
    label: t("income_10k_25k"),
  },
  {
    key: "25K – 50K",
    label: t("income_25k_50k"),
  },
  {
    key: "50K – 1L",
    label: t("income_50k_1l"),
  },
  {
    key: "1L – 2L",
    label: t("income_1l_2l"),
  },
  {
    key: "2L+",
    label: t("income_2l_plus"),
  },
];

// [t("marital_any"), t("marital_never_married"), t("marital_divorced"), t("marital_widowed")]
const maritalOptions = [
  {
    key: "Any",
    label: t("marital_any"),
  },
  {
    key: "Never Married",
    label: t("marital_never_married"),
  },
  {
    key: "Divorced",
    label: t("marital_divorced"),
  },
  {
    key: "Widowed",
    label: t("marital_widowed"),
  },
];
  return (
    <div className="app">
      { loading ? <Loader /> : '' }
      <div className="main-layout">
        <button
          className="mobile-filter-toggle"
          onClick={() => setMobileappliedFiltersOpen((v) => !v)}
        >
          {mobileappliedFiltersOpen
            ? `${t("closeAppliedFilters")}`
            : t("appliedFilters")}
        </button>

        <aside className={`match-sidebar ${mobileappliedFiltersOpen ? "open" : ""}`} >
          <h2 className="sidebar-title">{t("filter_title")}</h2>
          <p className="sidebar-sub">{t("filter_subtitle")}</p>

          {/* gender filter */}
          <div className="filter-section">

  <div className="filter-header">
    <img
      src={profileIcon}
      alt="gender"
      className="profile1-img"
    />

    <label className="filter-label">
      {t("gender_label")}
    </label>
  </div>

 <div className="chip-group">

  <button
    type="button"
    className={`chip ${
      appliedFilters.gender === "" ? "active" : ""
    }`}
    onClick={() =>
      setappliedFilters((prev) => ({
        ...prev,
        gender: "",
      }))
    }
  >
    Any
  </button>

  <button
    type="button"
    className={`chip ${
      appliedFilters.gender === "Male" ? "active" : ""
    }`}
    onClick={() =>
      setappliedFilters((prev) => ({
        ...prev,
        gender: "Male",
      }))
    }
  >
    Male
  </button>

  <button
    type="button"
    className={`chip ${
      appliedFilters.gender === "Female" ? "active" : ""
    }`}
    onClick={() =>
      setappliedFilters((prev) => ({
        ...prev,
        gender: "Female",
      }))
    }
  >
    Female
  </button>

  <button
    type="button"
    className={`chip ${
      appliedFilters.gender === "Other" ? "active" : ""
    }`}
    onClick={() =>
      setappliedFilters((prev) => ({
        ...prev,
        gender: "Other",
      }))
    }
  >
    Other
  </button>

</div>

</div>

          <div className="filter-section">
            <div className="filter-header">
              <img src={profileIcon} alt="profile" className="profile1-img" />
              <label className="filter-label">{t("age_range_label")}</label>
            </div>

            <div className="age-range-row">
              <span>{appliedFilters.ageMin} {t("age_unit")}</span>
              <span>{appliedFilters.ageMax} {t("age_unit")}</span>
            </div>

            <input
              type="range"
              min={18}
              max={50}
              value={appliedFilters.ageMin}
              onChange={(e) =>
                setappliedFilters({
                  ...appliedFilters,
                  ageMin: +e.target.value,
                })
              }
              className="range-slider"
            />
            <input
              type="range"
              min={18}
              max={50}
              value={appliedFilters.ageMax}
              onChange={(e) =>
                setappliedFilters({
                  ...appliedFilters,
                  ageMax: +e.target.value,
                })
              }
              className="range-slider"
            />
          </div>

          <div className="filter-section">
            <div className="filter-header">
              <img src={locationIcon} alt="location" className="location-img" />
              <label className="filter-label">{t("location_label")}</label>
            </div>

            <select
              className="filter-select"
              value={appliedFilters.location || ""}
              onChange={(e) => {
                const stateId = e.target.value;

                setappliedFilters((prev) => ({
                  ...prev,
                  location: stateId,
                }));

                getCityBasedonState(stateId);
              }}
            >
              <option value="">{t("select_state")}</option>

              {states.map((s) => (
                <option key={s._id} value={s._id}>
                  {s.masterValue?.[i18n.language] || s.masterValue?.en || ""}
                </option>
              ))}
            </select>

            <select
              className="filter-select"
              value={appliedFilters.city}
              onChange={(e) =>
                setappliedFilters({ ...appliedFilters, city: e.target.value })
              }
            >
              <option value="">{t("select_city")}</option>
              {cityOptions?.map((city) => (
                <option key={city._id} value={city._id}>
                  {city.masterValue?.[i18n.language] || city.masterValue?.en || ""}
                </option>
              ))}
              {/* {(cityOptions[appliedFilters.location] || []).map((city) => (
    <option key={city}>{city}</option>
  ))} */}
            </select>
          </div>

          <div className="filter-section">
            <div className="filter-header">
              <img src={religionIcon} alt="religion" className="religion-img" />
              <label className="filter-label">{t("religion_caste_label")}</label>
            </div>

            <select
              className="filter-select"
              value={appliedFilters.religion}
              onChange={(e) => {
                setappliedFilters({
                  ...appliedFilters,
                  religion: e.target.value,
                  caste: "Any Caste",
                });
                getCastBasedonReligion(e.target.value);
              }}
            >
              <option>{t("select_religion")}</option>
              {religion.map((r) => (
                <option
                  key={r._id}
                  value={r._id}
                >
                  {r.masterValue?.[i18n.language] || r.masterValue?.en || ""}
                </option>
              ))}
              {/* <option>Hindu</option>
    <option>Muslim</option>
    <option>Christian</option>
    <option>Jain</option> */}
            </select>

            <select
              className="filter-select"
              value={appliedFilters.caste}
              onChange={(e) =>
                setappliedFilters({ ...appliedFilters, caste: e.target.value })
              }
            >
              <option value="">{t("select_caste")}</option>
              {caste.map((c) => (
                <option key={c._id} value={c._id}>
                  {c.masterValue?.[i18n.language] || c.masterValue?.en || ""}
                </option>
              ))}
              {/* <option>Brahmin</option>
    <option>Mudaliar</option>
    <option>Nadar</option>
    <option>Gounder</option> */}
            </select>
          </div>

          <div className="filter-section">
            <div className="filter-header">
              <img
                src={educationIcon}
                alt="education"
                className="education-icon"
              />
              <label className="filter-label">{t("education_label")}</label>
            </div>

            <div className="chip-group">
              {education?.map((e) => (
                <button
                  key={e._id}
                  className={`chip ${appliedFilters.education.includes(e._id) ? "active" : ""}`}
                  onClick={() => toggleEducation(e._id)}
                >
                  {e.masterValue?.[i18n.language] || e.masterValue?.en || ""}
                </button>
              ))}
            </div>
          </div>

          <div className="filter-section">
            <div className="filter-header">
              <img src={bagIcon} alt="education" className="bagIcon-icon" />
              <label className="filter-label">{t("profession_label")}</label>
            </div>
            <select
              className="filter-select"
              value={appliedFilters.profession}
              onChange={(e) =>
                setappliedFilters({
                  ...appliedFilters,
                  profession: e.target.value,
                })
              }
            >
              <option value="">{t("select_profession")}</option>
              {profession.map((p) => (
                <option key={p._id} value={p._id}>
                  {p.masterValue?.[i18n.language] || p.masterValue?.en || ""}
                </option>
              ))}
              {/* <option>IT / Software</option>
              <option>Doctor</option>
              <option>Engineer</option>
              <option>Chartered Accountant</option>
              <option>Teacher</option> */}
            </select>
          </div>

          <div className="filter-section">
            <label className="filter-label">{t("marital_status_label")}</label>
            <div className="chip-group">
              {maritalOptions.map((m) => (
                <button
                  key={m.key}
                  className={`chip ${appliedFilters.marital.includes(m.key) ? "active" : ""}`}
                  onClick={() => toggleMarital(m.key)}
                >
                  {m.label}
                </button>
              ))}
            </div>
          </div>

          <div className="filter-section">
            <label className="filter-label">{t("height_label")}</label>
            <div className="height-row">
              <select
                className="filter-select half"
                value={appliedFilters.heightMin}
                onChange={(e) =>
                  setappliedFilters({
                    ...appliedFilters,
                    heightMin: e.target.value,
                  })
                }
              >
                {["4'10\"", "5'0\"", "5'2\"", "5'4\"", "5'6\""].map((h) => (
                  <option key={h}>{h}</option>
                ))}
              </select>
              <span className="to-label">to</span>
              <select
                className="filter-select half"
                value={appliedFilters.heightMax}
                onChange={(e) =>
                  setappliedFilters({
                    ...appliedFilters,
                    heightMax: e.target.value,
                  })
                }
              >
                {["5'6\"", "5'8\"", "5'10\"", "6'0\"", "6'2\""].map((h) => (
                  <option key={h}>{h}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="filter-section">
            <label className="filter-label"> {t("monthly_income_label")}</label>
            <div className="chip-group">
              {/* ["Any", "3–6L", "6–12L", "12–25L", "25L+"] */}
              {incomeOptions.map((i) => (
                <button
                  key={i.key}
                  className={`chip ${appliedFilters.income.includes(i.key) ? "active" : ""}`}
                  onClick={() => toggleIncome(i.key)}
                >
                  {i.label}
                </button>
              ))}
            </div>
          </div>

          <div className="filter-section">
            <label className="filter-label"> {t("lifestyle_label")}</label>
            <div className="chip-group">
              {lifestyleOptions.map(
                (l) => (
                  <button
                    key={l.key}
                    className={`chip ${appliedFilters.lifestyle.includes(l.key) ? "active" : ""}`}
                    onClick={() => toggleLifestyle(l.key)}
                  >
                    {l.label}
                  </button>
                ),
              )}
            </div>
          </div>

          <div className="filter-actions">
            <button
              className="btn-apply"
              onClick={() => {
                setPage(1);
                setMobileappliedFiltersOpen(false);
              }}
            >
              {t("btn_apply")}
            </button>
            <button
              className="btn-reset"
              onClick={() => {
                setappliedFilters(appliedFilters_INITIAL);
                setPage(1);
                setMobileappliedFiltersOpen(false);
              }}
            >
              {t("btn_reset")}
            </button>
          </div>
        </aside>

        <main className="content">
          {/* Search + Sort */}
          <div className="search-row">
            <div className="search-box">
              <span className="search-icon"></span>
              <img src={searchIcon} alt="search" className="search-icon" />
              <input
                type="text"
                placeholder={t("search_placeholder")}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="search-input"
              />
            </div>
            <select
              className="sort-select"
              value={sort}
              onChange={(e) => setSort(e.target.value)}
            >
              <option>{t("sort_most_relevant")}</option>
              <option>{t("sort_highest_match")}</option>
              <option>{t("sort_lowest_match")}</option>
            </select>
          </div>

          {/* Active appliedFilters */}
          <div className="active-filters">
            {activeappliedFilters.map((f, index) => (
              <span key={index} className="filter-tag">
                {f.label}
                <button
                  onClick={() => removeFilter(f.key, f.value)}
                  className="tag-remove"
                >
                  ✕
                </button>
              </span>
            ))}
          </div>

          <p className="results-count">
            <strong>{filteredProfiles?.length} {t("matches_found")}</strong> ·{" "}
            <span className="Showing">
              {t("showing_label")} {startIndex}–{endIndex} {t("of_label")} {total}
            </span>
          </p>

          {/* Recommended */}
          <section className="section">
            <h2 className="section-title">{t("recommended_title")}</h2>
            <p className="section-sub">
              {t("recommended_subtitle")}
            </p>
            <div className="rec-grid">
              {recommendedProfiles.length === 0 && (
                <p className="no-results">
                  {t("no_recommendations")}
                </p>
              )}
              {recommendedProfiles.map((p) => (
                <RecommendedCard
                  key={p._id}
                  profile={p}
                  onStar={toggleStar}
                  starred={starred.includes(p._id)}
                />
              ))}
            </div>
          </section>

          {/* All Matches */}
          <section className="section">
            <h2 className="section-title">{t("all_matches_title")}</h2>
            <p className="section-sub">
              {t("all_matches_subtitle")}   
            </p>
            <div className="profiles-grid">
              {paginatedProfiles.length === 0 && (
                <p className="no-results">
                  {t("no_matches_found")}
                </p>
              )}
              {paginatedProfiles.map((p) => (
                <ProfileCard
                  key={p._id}
                  profile={p}
                  onStar={toggleStar}
                  starred={starred.includes(p._id)}
                  onInterest={toggleInterest}
                  interested={interested.includes(p._id)}
                />
              ))}
              {/* {paginated.map((p) => (
                  <ProfileCard
                  key={p.id}
                  profile={p}
                  onStar={toggleStar}
                  starred={starred.includes(p.id)}
                  onInterest={toggleInterest}
                  interested={interested.includes(p.id)}
                />
              ))} */}
            </div>
          </section>

          {/* <div className="pagination">
            <button
              className="page-btn"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              ←
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
              <button
                key={n}
                className={`page-btn ${page === n ? "active" : ""}`}
                onClick={() => setPage(n)}
              >
                {n}
              </button>
            ))}
            <span className="page-ellipsis">…</span>
            <button
              className="page-btn"
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
            >
              →
            </button>
          </div> */}

          {totalPages > 1 && (
  <div className="pagination">

    {/* Previous */}
    <button
      className="page-btn"
      onClick={() => setPage((p) => Math.max(1, p - 1))}
      disabled={page === 1}
    >
      ←
    </button>

    {/* Page Numbers */}
    {getPageNumbers().map((n, index) => {
      if (n === "...") {
        return (
          <span
            key={`ellipsis-${index}`}
            className="page-ellipsis"
          >
            …
          </span>
        );
      }

      return (
        <button
          key={n}
          className={`page-btn ${page === n ? "active" : ""}`}
          onClick={() => setPage(n)}
        >
          {n}
        </button>
      );
    })}

    {/* Next */}
    <button
      className="page-btn"
      onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
      disabled={page === totalPages}
    >
      →
    </button>

  </div>
)}
        </main>
      </div>
      {toast && <div className={`toast ${toast.type}`}>{toast.msg}</div>}
    </div>
  );
}

// import { useState, useEffect, useCallback } from "react";
// import "./Matches.css";
// import profileIcon from "../icons/profile.png";
// import locationIcon from "../icons/location.png";
// import religionIcon from "../icons/religion.png";
// import educationIcon from "../icons/scholar.png";
// import bagIcon from "../icons/bag.png";
// import {
//   getMatches,
//   sendInterest,
//   addToShortlist,
//   removeFromShortlist,
// } from "../services/matchService";

// // ─── Helpers ─────────────────────────────────────────

// const getMatchColor = (score) => (score >= 50 ? "#7a6a00" : "#8b1a1a");

// function Avatar({ color, name, photoUrl }) {
//   if (photoUrl) {
//     return (
//       <div className="avatar" style={{ background: color }}>
//         <img src={photoUrl} alt={name} className="avatar-img" />
//       </div>
//     );
//   }

//   const initials = name?.split(" ").map((n) => n[0]).join("");

//   return (
//     <div className="avatar" style={{ background: color }}>
//       <span>{initials}</span>
//     </div>
//   );
// }

// function MatchBadge({ score }) {
//   return (
//     <span
//       className="match-badge"
//       style={{
//         background: getMatchColor(score) + "18",
//         color: getMatchColor(score),
//       }}
//     >
//       {score}% Match
//     </span>
//   );
// }

// // ─── MAIN COMPONENT ─────────────────────────────────────────

// export default function Matches() {
//   const [filters, setFilters] = useState({
//     ageMin: 24,
//     ageMax: 32,
//     city: "All Cities",
//     religion: "All Religions",
//     caste: "Any Caste",
//     education: ["Any"],
//     profession: "All Professions",
//     marital: ["Never Married"],
//   });

//   const [matches, setMatches] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   // ✅ FETCH MATCHES (FIXED)
//   const fetchMatches = useCallback(async () => {
//     setLoading(true);
//     setError("");

//     try {
//       const profileId = localStorage.getItem("profileId");

//       // ❌ STOP if missing
//       if (!profileId) {
//         setError("Please create your profile first.");
//         setLoading(false);
//         return;
//       }

//       const params = {
//         profileId, // 🔥 REQUIRED
//         minAge: filters.ageMin,
//         maxAge: filters.ageMax,
//       };

//       if (filters.city !== "All Cities") params.city = filters.city;
//       if (filters.religion !== "All Religions")
//         params.religion = filters.religion;
//       if (filters.caste !== "Any Caste") params.caste = filters.caste;
//       if (filters.profession !== "All Professions")
//         params.profession = filters.profession;

//       if (filters.education[0] !== "Any")
//         params.education = filters.education[0];

//       if (filters.marital.length)
//         params.maritalStatus = filters.marital[0];

//       const data = await getMatches(params);

//       setMatches(data.matches || []);
//     } catch (err) {
//       console.error(err);
//       setError(err.message || "Failed to load matches");
//     } finally {
//       setLoading(false);
//     }
//   }, [filters]);

//   useEffect(() => {
//     fetchMatches();
//   }, [fetchMatches]);

//   // ─── ACTIONS ─────────────────────────────────────────

//   const handleInterest = async (id) => {
//     try {
//       await sendInterest(id);
//       alert("Interest sent!");
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   const handleStar = async (id) => {
//     try {
//       await addToShortlist(id);
//       alert("Added to shortlist!");
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   // ─── UI ─────────────────────────────────────────

//   if (loading) return <p>Loading matches...</p>;
//   if (error) return <p style={{ color: "red" }}>{error}</p>;

//   return (
//     <div className="matches-container">
//       <h2>Matches</h2>

//       {matches.length === 0 && <p>No matches found</p>}

//       <div className="profiles-grid">
//         {matches.map((p) => (
//           <div key={p._id} className="profile-card">
//             <Avatar
//               name={p.fullName}
//               photoUrl={p.profileImage}
//               color="#eee"
//             />

//             <h3>{p.fullName}</h3>
//             <p>{p.age} yrs · {p.city}</p>
//             <p>{p.education} · {p.profession}</p>

//             <MatchBadge score={p.compatibilityScore} />

//             <div className="actions">
//               <button onClick={() => handleInterest(p._id)}>
//                 Send Interest
//               </button>

//               <button onClick={() => handleStar(p._id)}>
//                 ⭐ Save
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }
